"use client"

import Link from "next/link"

import { usePathname, useSearchParams } from "next/navigation"
import { useEffect, useRef, useState } from "react"
import { useAppContext } from '@/contexts/AppProviderContext.js';
// import Loading from "@/components/Atoms/Alerts/Loading";
import 'dotenv/config'
import { getCookies } from "@/utils/frontend/cookieOps";
import checkSignInStatus from "@/utils/frontend/checkSignInStatus";

import { ScrollContext } from "@/providers/ScrollProvider";
import AvatarImage from "@/components/Molecules/AvatarImage";
import { useContext } from "react";
import { UIContext } from "@/contexts/UIContext";

const MainNavbar_2 = ({user, lang, parent, mainNavbarVisible=true, mainNavbarFixed=true, appNotificationsArr = [], chatNotificationsArr = [], callback}) => {
  // console.log("NOTIFICATIONS@NAVBAR", notifications)
  const APP_MODE = process.env.NEXT_PUBLIC_APP_MODE
    const [showSidebarButton, setShowSidebarButton] = useState(false)
    const [sidebarOpen, setSidebarOpen] = useState(true)
    const [navbarOpen, setNavbarOpen] = useState()
    const [navbarVisible, setNavbarVisible] =useState(mainNavbarVisible) // will be used to control side vs top navbar in /social
    const [navbarFixed, setNavbarFixed] = useState(mainNavbarFixed)
    const [currentNavId, setCurrentNavId] = useState(0)

    // const [loading, setLoading] = useState(false)
    const [userIsSignedIn, setUserIsSignedIn] = useState(false)
    const pathname = usePathname()
    const searchParams = useSearchParams()
    const search = searchParams.get('url')
    
    const { scrollingUp, scrollingDown } = useContext(ScrollContext);
    

      const { supportModalOpen, setSupportModalOpen, sideNavbarPinned, setSideNavbarPinned, sideNavbarHovering, setSideNavbarHovering, thisUser, loading, setLoading } = useContext(UIContext);

    useEffect(() => {
      setNavbarVisible(mainNavbarVisible)
      setNavbarFixed(mainNavbarFixed)
}, [mainNavbarVisible, mainNavbarFixed])
    // const user = getCookies().user
 
    // useEffect(() => {
    //   const verifyUser = async (userType) => {
    //   try {
    //     if (userType === 'ROOT') { 
    //       setUserIsSignedIn(true)
    //     }
    //     else {
    //       setUserIsSignedIn(await checkSignInStatus(userType, 'include', undefined, undefined));
    //     }
    //   } catch (error) {
    //       console.error('Error checking sign-in status:', error);
    //   } finally {
    //       setLoading(false);
    //   }
    // };

    // if (user) {
    //   verifyUser(user.user_type)
    // }
    // }, [userIsSignedIn])
    
    


    const { baseUrl } = useAppContext()

    const [url, setUrl] = useState({
        // pathname: window.location.pathname.split(`/${lang}/`)[1] || '', 
        // search: window.location.search
      })


    const unreadAppNotifications = appNotificationsArr.filter(n => n.notification_status === 'INIT')
    const unreadChatNotifications = chatNotificationsArr.filter(n => n.notification_status === 'INIT')



    const sidebarControl = () => {
      if (sidebarOpen){
          setSidebarOpen(!sidebarOpen)
            console.log("sidebarOpen:", sidebarOpen)
            document.getElementById('sidebar').classList.remove('sm:translate-x-0') // works on desktop
            document.getElementById('leftCards')?.classList.remove('sm:ml-72')
            document.getElementById('searchBarMarket')?.classList.remove('sm:ml-72')
  
          // !sidebarOpen ? document.getElementById('table')?.classList.remove('sm:ml-64') : document.getElementById('table')?.classList.add('sm:ml-64')
  
            // document.getElementById('sidebar').classList.remove('-translate-x-full') // works on mobile
          //  callback({sidebarOpen: sidebarOpen})
      }
      else {
          setSidebarOpen(!sidebarOpen)
            console.log("sidebarOpen:", sidebarOpen)
            document.getElementById('sidebar').classList.add('sm:translate-x-0') // works on desktop
            document.getElementById('leftCards')?.classList.add('sm:ml-72')
            document.getElementById('searchBarMarket')?.classList.add('sm:ml-72')
            // document.getElementById('sidebar').classList.add('-translate-x-full') // works on mobile
          //  callback({sidebarOpen: sidebarOpen})
      }
    
    }



  
        /* ----------------------------------- 
          Detect user scrolling up / down - replaced by context
        ----------------------------------- */
        // const prevScrollY = useRef(0);

        // const handleScroll = () => {
        //   const currentScrollY = window.scrollY;
        //   if (currentScrollY < prevScrollY.current) {
        //     // setNavbarVisible(true)
        //     setTimeout(() => {
        //       setNavbarVisible(true)
        //     }, 250);
        //   } else if (currentScrollY > prevScrollY.current) {
        //     // setNavbarVisible(false)
        //     setTimeout(() => {
        //       setNavbarVisible(false)
        //     }, 250);
        //   }
        //   prevScrollY.current = currentScrollY;
        // };






     useEffect(() => {

      // if (pathname.startsWith('/admin')){
      //   setNavbarVisible(false)
      // }
      // else {
      //   setNavbarVisible(true)
      // }

      // if (scrollingUp) {
      //   setNavbarVisible(true)
      // }
      // else if (scrollingDown){
      //   setNavbarVisible(false)
      // }
        
        /* ----------------------------------- 
          Detect user scrolling up / down
        ----------------------------------- */
      // window.addEventListener('scroll', handleScroll, { passive: true });

      /* ----------------------------------- 
        Control navbar behavior (hide) in /social
      ----------------------------------- */
      // if (pathname?.includes('/social')){
      //   setNavbarVisible(false)
      // }
      // else{
      //   setNavbarVisible(true)
      // }
     
        setLoading(false)
        // Find the checkbox input by its id
        const checkbox = document.getElementById('check');
        // If the navbar is not open, uncheck the checkbox
        if (!navbarOpen && checkbox) {
          checkbox.checked = false;
        }

        setCurrentNavId(pathname.slice(1))

     // if document has sidebar, set sidebar button to true, else is false
     setShowSidebarButton(document.getElementById('sidebar'))
          setUrl({
          pathname: parent === 'LANG' ? window.location.pathname.split(`/${lang}/`)[1] || '' : window.location.pathname.split('/')[1] || '',
          search: window.location.search
          });
      // if url includes /workspace/, make the navbar not fixed (returns false below)
      // setNavbarFixed(!pathname.includes('/workspace')) // if url


      // Cleanup function runs on unmount
      // return () => window.removeEventListener('scroll', handleScroll);
     }, [search, pathname, navbarOpen, scrollingUp, scrollingDown])

return <header className="z-40">
    {/* {loading && <Loading lang={lang}/>} */}
  <nav className={`border-b-4 border-slate-50 dark:border-slate-900 opacity-95 bg-white dark:bg-slate-950 delay-150 transition-all duration-300 ${navbarFixed ? 'fixed' : 'flex justify-center'} w-full z-50 top-0 left-0 ${!navbarVisible ? ' -translate-y-full' : 'translate-y-0'}`}>
    {/* replaced sticky with hidden above */}
    {/* <div className="rounded-2xl shadow-xl border-4 dark:border-slate-800 bg-gray-200 dark:bg-slate-950 w-11/12 md:w-10/12 mx-auto justify-between items-center px-3"> */}

  {showSidebarButton && 

    <button
    className="fixed top-4 left-4 z-30 inline-flex items-center text-white cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent hidden sm:block outline-none focus:outline-none"
    type="button"
    onClick={() => sidebarControl()}
    >
      {/* <i className="fa-solid fa-bars text-gray-500"></i> */}
      {sidebarOpen === false ? 
      <i className="duration-300 fa-solid fa-bars text-black dark:text-white hover:text-gray-400 text-base"></i> 
      : sidebarOpen === true ? 
      <i className="duration-300 fa-solid fa-x text-black dark:text-white hover:text-gray-400 text-base"></i> : '' }

    </button>
    }


    <ul className={`navigation w-full max-w-[90vw] flex flex-wrap justify-between items-center relative ${navbarFixed ? 'mx-auto' : 'mx-4'} py-4`}>


      {/* removed py-4 from above */}
      {/* <a class="logo" href="#">
        <h3 class="font-bold text-2xl">LOGO</h3>
        </a> */}


      <div className="sm:flex sm:justify-center sm:items-center ml-0 sm:mx-8 hover:opacity-50 ease-in-out duration-300 transition-all">
        <Link onClick={()=>{setCurrentNavId('feed'); setLoading(currentNavId !== 'feed')}} className="logo" href ={
          (user?.user_type === 'GUEST' || !user) ? '/' : '/feed'
          }>
            <img src={`${baseUrl}/RECTANGLE_TRANSPARENT_LOGO.png`} className="h-8" alt="Talnet Logo" />
          </Link>
      </div>

      <input type="checkbox" id="check" />

      <span className="text-black dark:text-white bg-gray-200 dark:bg-slate-700 md:bg-white md:dark:bg-slate-950 menu flex font-ubuntu font-extralight dark:text-white [&>li]:pl-6 [&>li>a]:text-center [&>li>a]:relative [&>li>a]:transition [&>li>a]:duration-300 [&>li>a]:ease-in-out  [&>li>a]:font-normal [&>li>a]:text-lg ">



      <li className={`hover:underline decoration-4 underline-offset-4 decoration-teal-300 ${currentNavId==='pricing' && 'underline'}`}>
        <Link onClick={()=>{setNavbarOpen(false); setCurrentNavId('pricing'); setLoading(currentNavId !== 'pricing')}} href = {`/pricing`}>
        Pricing
        </Link>
          </li>

        {(APP_MODE === "COMMON" || (user && user.user_type !== 'GUEST')) && 
        <li className={`hover:underline decoration-4 underline-offset-4 decoration-teal-300 ${currentNavId==='jobs' && 'underline'}`}>
          <Link onClick={()=>{setNavbarOpen(false);  setCurrentNavId('jobs'); setLoading(currentNavId !== 'jobs')}} href = {`/jobs`}>
          {lang === 'fr' ? 'Marché Emploi' : 'Job Marketplace'}
        </Link>
          </li>
        }

        {APP_MODE === "COMMON" && 
        <li className={`hover:underline decoration-4 underline-offset-4 decoration-teal-300 ${currentNavId==='talent' && 'underline'}`}>
        <Link onClick={()=>{setNavbarOpen(false);  setCurrentNavId('talent'); setLoading(currentNavId !== 'talent')}} href = {`/talent`}>
        {lang === 'fr' ? 'Marché Talents' : 'Talent Marketplace'}
        </Link>
          </li>
        }

        <li className={`hover:underline decoration-4 underline-offset-4 decoration-teal-300 ${currentNavId==='feed' && 'underline'}`}>
        <Link onClick={()=>{setNavbarOpen(false); setCurrentNavId('feed'); setLoading(currentNavId !== 'feed')}} href = {`/feed`}>
        Feed
        </Link>
          </li>



        {/* <li className={`hover:text-slate-400`}>
        <Link onClick={()=>{setNavbarOpen(false); setLoading(true)}} href = {`https://talnet.co/space/forums`}>
        {lang === 'fr' ? 'Forums' : 'Forums'}
        </Link>
          </li>

        <li className={`hover:text-slate-400`}>
        <Link onClick={()=>{setNavbarOpen(false); setLoading(true)}} href = {`https://talnet.co/space/blog`}>
        {lang === 'fr' ? 'Blog' : 'Blog'}
        </Link>
          </li> */}

          {/* <li className={`hover:text-slate-400 ${currentNavId===3 && 'text-slate-400'}`}>
        <Link onClick={()=>{setNavbarOpen(false);  setCurrentNavId(3); setLoading(true)}} href = {`/${lang}/pricing`}>
        {lang === 'fr' ? 'Prix' : 'Pricing'}
        </Link>
          </li> */}


  
        {/* <li className={`hover:text-gray-400 ${currentNavId===6 && 'text-gray-400'}`}>
        <Link onClick={()=>{setNavbarOpen(false); setCurrentNavId(6)}} href = {`/${lang === 'fr' ? 'fr/blog' : 'blog'}`}>
        Blog
        </Link>
        </li> */}


        {/* <li className="hover:text-gray-400">
          <Link href={`${lang}/employers/workspace`} className="px-4 py-2 bg-indigo-500 rounded-lg text-white duration-500 hover:bg-indigo-600">
            <span className="font-base text-sm"> {lang === 'fr' ? 'Afficher un Emploi' : 'Post a Job'}</span>
          </Link>
        </li> */}


{/*====================
---WORKSPACE
=====================*/}
{user && user.user_type !== 'GUEST' &&
  <li className="hover:underline decoration-4 underline-offset-4 decoration-teal-300">
    {/* <AvatarImage size={'xs'} module={'USER'} data={user}/>  */}
  {/* <Link
  onClick={()=>{setNavbarOpen(false);setLoading(true);setCurrentNavId(null)}}
    href={`/workspace`}
        className="relative px-4 py-2 rounded-lg text-white bg-teal-500 border-4 border-teal-300 duration-500 hover:bg-teal-600">
   
    <span className="font-base text-sm ">
       {`${user.user_first_name}'s Workspace`}
    </span>
  </Link> */}
   <Link
  onClick={()=>{setNavbarOpen(false);setLoading(currentNavId !=='workspace');setCurrentNavId('workspace')}}
    href={`/workspace`}
        className="relative underline decoration-4 underline-offset-4 decoration-teal-300 py-2 rounded-md hover:border-teal-400  border-black dark:border-white duration-500"
  >
     {`${user.user_first_name}'s Workspace`}
     </Link>
</li>
  }

{/*====================
---USER SPACE
=====================*/}
{user && user.user_type !== 'GUEST' &&
<>
{/* separator */}
<span className="xs:hidden min-[1000px]:inline font-normal text-3xl ml-[1.5rem] border-r border-slate-200"></span>

<span className="flex flex-col min-[1000px]:flex-row text-lg ml-[1.5rem]">

  {/*====================
  ---CHAT
  =====================*/}
  <li className="decoration-4 underline-offset-4 decoration-teal-300">
    <Link
      onClick={() => {
        callback({ chatNotificationsModalOpen: true });
        setNavbarOpen(false);
      }}
      href="/workspace/chat"
      className="relative md:px-2 transition duration-100 ease-in-out hover:bg-slate-200 dark:hover:bg-slate-800 py-2 rounded text-center"
      // items-center flex
    >

        <i className={`min-w-5 md:min-w-6 fa-regular fa-envelope`}></i>
      

      
      <span className="xs:inline min-[1000px]:hidden font-normal text-3xl ml-2">Chat</span>
    </Link>
      
  </li>


  {/*====================
  ---NOTIFICATIONS
  =====================*/}
  <li className="decoration-4 underline-offset-4 decoration-teal-300">
    <Link
      onClick={() => {
        callback({ notificationsModalOpen: true });
        setNavbarOpen(false);
      }}
      href="#"
      className="relative md:px-2 transition duration-100 ease-in-out hover:bg-slate-200 dark:hover:bg-slate-800 py-2 rounded text-center"
    >
      
      <i
        className={`min-w-5 md:min-w-6 ${
          unreadAppNotifications.length > 0
            ? "fa-solid text-teal-400"
            : "fa-regular"
        } fa-bell`}
      ></i>

      {unreadAppNotifications.length > 0 && (
        <span className="absolute -top-1 -right-1 z-10 min-w-4 h-4 px-1 flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold leading-none">
          {unreadAppNotifications.length}
        </span>
      )}
      
      <span className="xs:inline min-[1000px]:hidden font-normal text-3xl ml-2">Notifications</span>
    </Link>
      
  </li>

</span>
</>
}

{(user?.user_type === 'GUEST' || !user) && 
<li className="hover:underline decoration-4 underline-offset-4 decoration-teal-300">
  <Link
  onClick={()=>{setNavbarOpen(false);setLoading(true)}}
    href={`/auth/signin`}
        className="relative py-2 rounded-md hover:border-teal-400  border-black dark:border-white duration-500"
  >
    {/* <span className="font-base text-lg"> */}
      {lang === 'fr' ? 'Connexion' : 'Sign In'}
    {/* </span> */}
  </Link>
</li>}

{(user?.user_type === 'GUEST' || !user) && 
<li className="hover:text-teal-300">
  {/* <Link
  onClick={()=>{setNavbarOpen(false);setLoading(true)}}
    href={`/auth/signup`}
        className="px-8 py-2 rounded-lg text-white bg-teal-400 border-4 border-teal-300 duration-500 hover:bg-teal-500"
  >  */}
  <Link
  onClick={()=>{setNavbarOpen(false);setLoading(true)}}
    href={`/auth/signup`}
        className="relative underline decoration-4 underline-offset-4 decoration-teal-300 py-2 rounded-md hover:border-teal-400  border-black dark:border-white duration-500"
  >
  Join Talnet
    {/* <span className="inline-flex items-start whitespace-nowrap justify-center min-w-32 text-lg"> Join Talnet  */}
      {/* <i className={`fa-solid fa-arrow-right text-lg text-teal-300 -rotate-45`}/> */}
      {/* </span> */}
  

  </Link>



                {/* <Link
              href={`/auth/signup`}
                  className="rounded-lg duration-500 hover:border-teal-400 font-ubuntu font-bold">
      
                      <span className="flex flex-row gap-2">
                 <span className="hover:underline text-black dark:text-white decoration-4 underline-offset-4 decoration-teal-300">
                <p className="font-ubuntu">Join Talnet</p>
                </span>
                 <span className="flex items-start justify-center -rotate-45"><i className={`fa-solid fa-arrow-right text-lg text-teal-300`}/>
                 </span>
                </span>
               <p className="text-xs font-light underline-none italic font-inter">Forever free. No credit card.</p>
         
            </Link> */}

            
</li>}




    
        <label htmlFor="check" className="close-menu mr-4 flex ">
        <i className="fa-solid fa-x text-black dark:text-white hover:text-slate-400 duration-200 text-base"/>
        </label>
      </span>


      <label htmlFor="check" className="open-menu dark:text-white">
      <i onClick={()=>setNavbarOpen(!navbarOpen)} className="duration-300 fa-solid fa-bars text-black dark:text-white hover:text-slate-400 text-base"></i>
      </label>



    </ul>

    {/* </div> */}
  </nav>
</header>
}

export default MainNavbar_2